module.exports = "<div class=\"margin-sm\">\r\n\t<div class=\"margin-lg\">\r\n\t\t<button class=\"ui-button ui-button-primary\"\r\n\t\t\tng-disabled=\"$ctrl.clasificando\"\r\n\t\t\ttype=\"submit\"\r\n\t\t\tng-click=\"$ctrl.clasificarMovimientos()\">Clasificar todos\r\n\t\t</button>\r\n\t</div>\r\n\t<div ng-repeat=\"item in $ctrl.data\">\r\n\t\t<finanzas-clasificarmovimientos-individual-lista-item\r\n\t\t\tdata=\"item\"></finanzas-clasificarmovimientos-individual-lista-item>\r\n\t</div>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/finanzas/_/clasificarmovimientos/components/individual/lista/template.html
// module id = 2905
// module chunks = 0